<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-card>
		<v-card-title class="mt-3">
			<h1>Monitoring</h1>
		</v-card-title>
		<v-card-text v-if="hasForm">
			<v-container fluid>
				<div v-if="monitoringReports.length > 0">
					<v-layout mb-3 align-center>
						<h3>Lista raportów z monitoringu</h3>
						<v-btn @click="createMonitoringReport"
							v-if="monitoringCreateAccess()" class="success"
							style="float: left">Dodaj raport
						</v-btn>
					</v-layout>
					<v-layout v-for="monitoring in monitoringReports" v-bind:key="monitoring.id">
						<div>
							<span v-if="monitoring.status === 'FINISHED'">
								Zakończony {{monitoring.finishDate}} przez użytkownika {{monitoring.finisher}}
							</span>
							<span v-if="monitoring.status === 'STARTED'">
								Rozpoczęty {{monitoring.creationDate}} przez użytkownika {{monitoring.creator}}
							</span>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn icon
										:disabled="!canEditMonitoring(monitoring)"
										@click="navigateToMonitoring(monitoring.id)">
										<v-icon v-on="on">
											edit
										</v-icon>
									</v-btn>
								</template>
								<span>Edycja</span>
							</v-tooltip>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn icon
										@click="navigateToMonitoringView(monitoring.id)">
										<v-icon v-on="on">
											description
										</v-icon>
									</v-btn>
								</template>
								<span>Podgląd</span>
							</v-tooltip>
							<v-tooltip bottom v-if="canDeleteMonitoring(monitoring)">
								<template v-slot:activator="{ on }">
									<v-btn icon
										@click="deleteMonitoring(monitoring.id)">
										<v-icon v-on="on" color="lightred">
											delete
										</v-icon>
									</v-btn>
								</template>
								<span>Usuń</span>
							</v-tooltip>
						</div>
					</v-layout>
				</div>
				<v-layout v-else align-center fill-height>
					<h3>Monitoring projektu nie został jeszcze przeprowadzony</h3>
					<v-btn @click="createMonitoringReport" class="success">Dodaj raport</v-btn>
				</v-layout>

			</v-container>
		</v-card-text>
		<v-card-text v-else>
			<h3 class="ml-4 mt-4">Formularz raportu z monitoringu powinien być zdefiniowany.</h3>
		</v-card-text>
		<v-container fluid>
		<v-layout><h3>Uwagi</h3></v-layout>
			<v-layout>
				<v-flex>
					<v-textarea outline auto-grow v-model="project.monitoringRemarks"
						browser-autocomplete="off" aria-label="monitoring remarks"></v-textarea>
				</v-flex>
			</v-layout>
			<v-btn primary @click="saveAgencyProjectMonitoringRemarks">Zapisz</v-btn>
		</v-container>	
	</v-card>
</template>

<script>

	import {AgencyMonitoring} from "../../../api/generated/AgencyMonitoring";
	import {AgencyProject} from "../../../api/generated/AgencyProject";

	export default {
		name: "AgencyProjectMonitoringList",
		data() {
			return {
				projectStatus: null,
				monitoringReports: [],
				editedItem: {},
				hasForm: false,
				projectId: this.$route.params.projectId,
				isSupervisor: false,
			};
		},
		props: {
			project: {
				type: Object
			},
		},
		created() {
			this.loadData();
		},

		methods: {
			loadData() {
				AgencyMonitoring.getConfiguration(this, this.$route.params.projectId, successResponse => {
					this.hasForm = successResponse !== null && successResponse.schema !== '' && successResponse.schema !== null;
				});
				AgencyMonitoring.getList(this, this.$route.params.projectId, successResponse => {
					this.monitoringReports = successResponse;
				});
				AgencyProject.getStatus(this, this.$route.params.projectId, successResponse => {
						this.projectStatus = successResponse.agencyProjectStatus;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować statusu konkursu", errorResponse);
					});
				AgencyProject.getIsSupervisor(this, this.$route.params.projectId, successResponse => {
						this.isSupervisor = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować statusu użytkownika", errorResponse);
					});
			},

			createMonitoringReport() {
				if (!this.projectStatus || this.projectStatus === 'WITHDRAWN') {
					this.$messagesBus.$emit("error", "Nieodpowiedni status konkursu");
					return;
				}
				AgencyMonitoring.post(this, this.$route.params.projectId, success => {
					this.navigateToMonitoring(success);
				});
			},
			navigateToMonitoring(monitoringId) {
				this.$router.push("/app/agency-contest/" + this.$route.params.id + "/" + this.$route.params.projectId + "/monitoring-form/" + monitoringId);
			},

			navigateToMonitoringView(monitoringId) {
				this.$router.openInNewTab("/view/agency-project/" + this.projectId + "/monitoring-form/" + monitoringId);
			},

			deleteMonitoring(monitoringId) {
				this.$confirm("Czy na pewno chcesz usunąć monitoring?", {
					icon: 'delete',
					title: 'Usuwanie monitoringu',
					color: "primary",
					width: 500
				})
					.then(response => {
						if (response) {
							AgencyMonitoring.delete(this, monitoringId,
								() => {
									this.loadData();
									this.$messagesBus.$emit("success", "Pomyślnie usunięto raport z monitoringu");
								},
								() => {
									this.$messagesBus.$emit("error", "Nie udało się usunąćraportu z monitoringu");
								});
						}
					});
			},


			monitoringCreateAccess () {
				return (this.isSupervisor || this.roles.isLocalAdministrator() || this.roles.isAdministrator()) &&
					this.monitoringReports[this.monitoringReports.length - 1].status === 'FINISHED';
			},
			hasAgencyProjectPanelAdminModificationAccess(){
				return this.$store.state.agencyProjectPanelPermissions.hasAgencyProjectPanelAdminModificationAccess;
			},
			canEditMonitoring(monitoring) {
				return (monitoring.status === 'STARTED' || (monitoring.status === 'FINISHED' && this.hasAgencyProjectPanelAdminModificationAccess()));
			},
			canDeleteMonitoring(monitoring){
				return monitoring.status === 'FINISHED' && this.hasAgencyProjectPanelAdminModificationAccess();
			},
			saveAgencyProjectMonitoringRemarks() {
				AgencyProject.putMonitoringRemarks(this, this.$route.params.projectId, {body: this.project.monitoringRemarks});
			}
		},
	};
</script>

<style scoped>

</style>
